/**
 * @file Slider.jsx
 * @description Sección hero con contenido introductorio y botón CTA.
 */

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Slider = () => {
  return (
    <section id="intro">
      <Container>
        <Row className="justify-content-md-center text-center">
          <Col md={7}>
            <h1>Sabores Auténticos de Lima</h1>

            <a className="btn-primary" href="#menu">
              Ver Nuestro Menú
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Slider;
